import { render, staticRenderFns } from "./IdentityVerification.vue?vue&type=template&id=cb45c9dc&scoped=true&"
import script from "./IdentityVerification.vue?vue&type=script&lang=ts&"
export * from "./IdentityVerification.vue?vue&type=script&lang=ts&"
import style0 from "./IdentityVerification.vue?vue&type=style&index=0&id=cb45c9dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb45c9dc",
  null
  
)

export default component.exports